(function() {
	document.addEventListener("DOMContentLoaded", function() {

		var licenseImage = document.getElementById("licenseImage");
		var uploadButton = document.getElementById("licenseUpload");
		var licenseInput = document.getElementById("dealerLicense");
		var submitButton = document.querySelector("#settings input[type='submit']");

		if(licenseImage === null && uploadButton instanceof HTMLLabelElement && licenseInput instanceof HTMLInputElement) {

			licenseInput.addEventListener("change", function() {
				if(this.value) createErrMessage();
				else createErrMessage(true);
			});


			if(submitButton) submitButton.addEventListener("click", function() {
				if(!licenseInput.value) createErrMessage(true);
				else createErrMessage();
			});

			// remove file from input
			document.addEventListener("click", function(event) {
				event = event || window.event;
				var target = event.target;

				if(target instanceof HTMLElement && target.classList.contains("imglist__delcheck")) {
					licenseInput.value = null;
					createErrMessage(true);
				}
					
			});

		}

		// FUNCTIONS
		function createErrMessage(flag) {
			var errorElem;
			var errorElemID = "licenseErrorMsg";
			var message;

			if(flag) message = "License is required";
			else message = "";

			if(document.getElementById(errorElemID)) errorElem = document.getElementById(errorElemID);
			else {
				errorElem = document.createElement("div");
				errorElem.id = errorElemID;
				errorElem.classList.add("red");
				
				if(uploadButton) {
					if(uploadButton.nextElementSibling)
						uploadButton.parentElement.insertBefore(errorElem, uploadButton.nextElementSibling);
					else uploadButton.parentElement.appendChild(errorElem);
				}
			}

			errorElem.textContent = message;
		}

	});
})();